module.exports = __webpack_public_path__ + "static/img/bg-ar.2d7bcdbe.webp";